// extracted by mini-css-extract-plugin
var _1 = "styles-module__adminButtons___NLPGp";
var _2 = "styles-module__container___ZkDp2";
var _3 = "styles-module__newWaypointContainer___vI2mT";
export { _1 as "adminButtons", _2 as "container", _3 as "newWaypointContainer" }
